import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import {requestLogin} from "./http";
import {message} from "antd";

// 创建一个实例，此后都在此实例上改造
const request = axios.create({
  baseURL:"/",
  timeout: 1000 * 4,
  withCredentials: true,
});

// 请求拦截器
const beforeRequest = (config: AxiosRequestConfig) => {
  // 设置 token
  const token = localStorage.getItem('Authorization');
  if (token) {
    // 确保 config.headers 存在且是一个对象
    config.headers = config.headers || {};
    config.headers['Authorization']="Bearer " + token;
  }

  return config;
};

// @ts-ignore
request.interceptors.request.use(beforeRequest);

// 响应拦截器
const responseSuccess = async (response: AxiosResponse) => {
  // 这里没有必要进行判断，axios 内部已经判断
  // const isOk = 200 <= response.status && response.status < 300
  // 如果 response.data.code 为 1，则重新发一次请求
  if (response.data.code === 1 && localStorage.getItem('remember')) {
    try {

    let result = await  requestLogin({ username:localStorage.getItem('username'), password: localStorage.getItem('password') })
      if (result.data.code === 0) {
        localStorage.setItem('Authorization', result.data.data.token);
      } else {
        message.error('请求错误');
      }
      // 重新发送请求
      const newResponse = await axios.request(response.config);
      return Promise.resolve(newResponse.data);  // 返回新的请求结果
    } catch (error) {
      return Promise.reject(error);  // 如果重新请求失败，返回错误
    }
  }

  // 如果不满足条件，直接返回原始的响应数据
  return Promise.resolve(response.data);
};

const responseFailed = (error: AxiosError) => {
  const { response } = error;
  if (response) {
    // handleError(response);
    // const error = new Error(response.data.msg);
    return Promise.reject();
  } else if (!window.navigator.onLine) {
    return Promise.reject(new Error('请检查网络连接'));
  }
  return Promise.reject(error);
};

request.interceptors.response.use(responseSuccess, responseFailed);

export default request;
